import {
  MinorsTermAcceptanceData,
  MinorsTermData,
} from '../components/MinorAccessRequestModal/types'

class GetMinorsTermAcceptanceData {
  toDomain(data: MinorsTermAcceptanceData): MinorsTermData {
    return {
      acceptanceTermId: data?.idTermoAceite,
      confirmationTimestamp: data?.dataHoraConfirmacao,
      guardianCellphone: data?.telefoneResponsavel,
      guardianCPF: data?.cpfResponsavel,
      guardianBirthdate: data?.dataNascimentoResponsavel,
      guardianEmail: data?.emailResponsavel,
      guardianFullName: data?.nomeResponsavel,
      patientFullName: data?.nomePaciente,
      patientId: data?.idPaciente,
      relationship: data?.grauParentesco,
      sentTimestamp: data?.dataHoraEnvio,
      idClinic: data?.idClinica,
    }
  }
}

export default new GetMinorsTermAcceptanceData()
